import React from 'react';
import { ShieldIcon } from 'lucide-react';
export const Benefits = () => {
  return <section className="mb-10" data-id="element-20">
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100" data-id="element-21">
        <div className="flex items-center mb-4" data-id="element-22">
          <ShieldIcon className="w-8 h-8 text-blue-600 mr-3" data-id="element-23" />
          <h2 className="text-xl font-bold text-blue-800" data-id="element-24">
            Mijn Belofte Aan Jou
          </h2>
        </div>
        <p className="mb-4 leading-relaxed" data-id="element-25">
          Ik beloof dat je na dit gratis webinar met minimaal 3 praktische
          technieken weggaat die je direct kunt toepassen om beter met je hond
          te communiceren.
        </p>
        <p className="mb-4 leading-relaxed" data-id="element-26">
          Dit is geen theoretische presentatie, maar een praktische workshop vol
          met demonstraties en voorbeelden die je direct kunt gebruiken.
        </p>
        <p className="font-semibold text-blue-800" data-id="element-27">
          Of je nu een puppy hebt of een oudere hond met gedragsproblemen, deze
          technieken werken voor elke hond, ongeacht ras, leeftijd of
          temperament.
        </p>
      </div>
    </section>;
};